import {makeStyles, Paper, Theme} from '@material-ui/core';
import React from 'react';
import {$enum} from 'ts-enum-util';
import {ChartIcon, ContactIcon, VideoIcon} from '../../assets/UiIcons';
import {DialogContentType} from './QuickMenu';
import {colors} from '../../theme/theme';
import {AppState, SalesType} from "../../types/redux";
import {useSelector} from "react-redux";

const btnSizeMobile = 60;

const useQuickMenuStyles = makeStyles((theme: Theme) => ({
	quickMenu: {
		position: 'fixed',
		top: 77,
		right: 0,
		backgroundColor: colors.white,
		zIndex: theme.zIndex.modal,
	},
	quickMenuBtn: {
		cursor: 'pointer',
		width: btnSizeMobile,
		height: btnSizeMobile,
		padding: 12,
	},
	btnIcon: {
		width: '100%',
		height: '100%',
		color: theme.palette.primary.main,
		'&.is-active': {
			color: colors.grayA50,
		},
	},
	dialogPaper: {
		minHeight: '80vh',
		marginRight: btnSizeMobile + theme.spacing(2) + 32,
		width: `calc(100% - ${2 * 32 + btnSizeMobile + theme.spacing(2)}px)`,
	},
	dialogTitle: {
		padding: theme.spacing(2, 4, 2),
		backgroundColor: theme.palette.grey[100],
		[theme.breakpoints.up('sm')]: {
			padding: theme.spacing(4, 6, 2),
		},
	},
	dialogContent: {
		padding: theme.spacing(0, 4, 2),
		[theme.breakpoints.up('sm')]: {
			padding: theme.spacing(1, 6, 4),
		},
	},
	tabBar: {
		backgroundColor: colors.white,
	},
}));

export const QuickMenuBar: React.FC<{
	open: boolean;
	activeEntry: DialogContentType | null;
	handleClick(tab: DialogContentType): void;
}> = ({ open, activeEntry, handleClick }) => {
	const classes = useQuickMenuStyles();

	const getButtonIcon = (
		type: DialogContentType | null
	): JSX.Element | null => {
		if (!type) {
			return null;
		}
		let Icon = null;

		switch (type) {
			case DialogContentType.CONTACT:
				Icon = ContactIcon;
				break;
			case DialogContentType.INFO:
				Icon = ChartIcon;
				break;
			case DialogContentType.VIDEO:
				Icon = VideoIcon;
		}

		return (
			Icon && (
				<Icon
					onClick={() => handleClick(type)}
					className={`${classes.btnIcon} ${
						open && activeEntry === type ? 'is-active' : ''
					}`}
				/>
			)
		);
	};
	const salesTypes = useSelector<AppState, SalesType[]>( state => state.user.salesType );

	const getButtons = $enum(DialogContentType)
		.getValues()
		.filter(ta => (ta===DialogContentType.CONTACT && (salesTypes.includes(SalesType.EPK) || salesTypes.includes(SalesType.EPH)))
			|| (!salesTypes.includes(SalesType.EPK) || !salesTypes.includes(SalesType.EPH))  );

	return (
		<Paper elevation={1} square className={classes.quickMenu}>
			{getButtons.map((type) => (
					<div className={classes.quickMenuBtn} key={type}>
						{getButtonIcon(type)}
					</div>
				))}
		</Paper>
	);
};
